(function () {
  var loader = document.querySelector('[data-page-loader]');
  if (loader) {
    window.addEventListener('load', function () {
      loader.classList.add('is-hidden');
      setTimeout(function () { loader.remove(); }, 350);
    });
  }

  document.querySelectorAll('[data-countdown]').forEach(function (node) {
    var targetText = node.getAttribute('data-countdown');
    var fallbackHours = parseInt(node.getAttribute('data-fallback-hours') || '8', 10);
    var target = targetText ? new Date(targetText) : new Date(Date.now() + fallbackHours * 60 * 60 * 1000);
    if (Number.isNaN(target.getTime())) target = new Date(Date.now() + fallbackHours * 60 * 60 * 1000);
    function tick() {
      var diff = Math.max(0, target.getTime() - Date.now());
      var hours = Math.floor(diff / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      var h = node.querySelector('[data-hours]');
      var m = node.querySelector('[data-minutes]');
      var s = node.querySelector('[data-seconds]');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
      if (s) s.textContent = String(seconds).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });
})();

/* ===== Product marquee: auto-scroll + arrows + quick view ===== */
(function () {
  function initMarquee(pm) {
    var viewport = pm.querySelector('[data-pm-viewport]');
    var track = pm.querySelector('[data-pm-track]');
    if (!viewport || !track) return;
    var speed = parseFloat(pm.getAttribute('data-speed') || '40');
    var autoplay = pm.getAttribute('data-autoplay') !== 'false';
    var half = 0;
    function measure() { half = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);

    function wrap() {
      if (half <= 0) return;
      if (viewport.scrollLeft >= half) viewport.scrollLeft -= half;
      else if (viewport.scrollLeft < 0) viewport.scrollLeft += half;
    }

    var paused = false;
    viewport.addEventListener('mouseenter', function () { paused = true; });
    viewport.addEventListener('mouseleave', function () { paused = false; });
    viewport.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    viewport.addEventListener('scroll', wrap);

    var last = null;
    function step(ts) {
      if (last === null) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if (autoplay && !paused && half > 0) { viewport.scrollLeft += speed * dt; wrap(); }
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);

    function cardStep() {
      var c = track.querySelector('.pm-card');
      if (!c) return 280;
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      return (c.getBoundingClientRect().width + gap) * 2;
    }
    var prev = pm.querySelector('[data-pm-prev]');
    var next = pm.querySelector('[data-pm-next]');
    if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
  }

  function initQuickView(section) {
    var modal = section.querySelector('[data-pm-modal]');
    if (!modal) return;
    function set(sel, val) { var el = modal.querySelector(sel); if (el) el.textContent = val || ''; }
    function open(card) {
      var d = card.dataset;
      var img = modal.querySelector('[data-pm-img]'); if (img) { img.src = d.image || ''; img.alt = d.title || ''; }
      set('[data-pm-title]', d.title);
      set('[data-pm-vendor]', d.vendor);
      set('[data-pm-price]', d.price);
      var comp = modal.querySelector('[data-pm-compare]'); if (comp) { comp.textContent = d.compare || ''; comp.style.display = d.compare ? '' : 'none'; }
      set('[data-pm-desc]', d.desc);
      var badge = modal.querySelector('[data-pm-badge]');
      if (badge) { if (d.discount && d.discount !== '0') { badge.textContent = '-' + d.discount + '%'; badge.hidden = false; } else { badge.hidden = true; } }
      var link = modal.querySelector('[data-pm-link]'); if (link) link.href = d.url || '#';
      var form = modal.querySelector('[data-pm-form]');
      var variant = modal.querySelector('[data-pm-variant]');
      if (form && variant) { if (d.variant) { variant.value = d.variant; form.style.display = ''; } else { variant.value = ''; form.style.display = 'none'; } }
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    section.querySelectorAll('[data-pm-quickview]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('[data-pm-card]');
        if (card) open(card);
      });
    });
    modal.querySelectorAll('[data-pm-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pm-section]').forEach(function (pm) {
      if (pm.dataset.pmInit) return;
      pm.dataset.pmInit = '1';
      var section = pm.closest('section') || pm;
      initMarquee(pm);
      initQuickView(section);
    });
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* ===== Header: nav drawer + search toggle, and hero image slideshow ===== */
(function () {
  function initHeader(root) {
    var scope = root || document;

    var drawer = scope.querySelector('[data-drawer]');
    if (drawer && !drawer.dataset.init) {
      drawer.dataset.init = '1';
      var open = function () { drawer.hidden = false; requestAnimationFrame(function () { drawer.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; };
      var close = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { drawer.hidden = true; }, 280); };
      scope.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
    }

    var panel = scope.querySelector('[data-search-panel]');
    var toggle = scope.querySelector('[data-search-toggle]');
    if (panel && toggle && !panel.dataset.init) {
      panel.dataset.init = '1';
      toggle.addEventListener('click', function () {
        var show = panel.hidden;
        panel.hidden = !show;
        toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
        if (show) { var inp = panel.querySelector('[data-search-input]'); if (inp) inp.focus(); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
    }
  }

  function initHeroSlides(root) {
    (root || document).querySelectorAll('[data-lux-slides]').forEach(function (stage) {
      if (stage.dataset.luxInit) return;
      stage.dataset.luxInit = '1';
      var slides = stage.querySelectorAll('[data-lux-slide]');
      if (slides.length < 2) return;
      var i = 0;
      var interval = (parseFloat(stage.getAttribute('data-lux-interval')) || 4) * 1000;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  if (document.readyState !== 'loading') { initHeader(); initHeroSlides(); }
  else document.addEventListener('DOMContentLoaded', function () { initHeader(); initHeroSlides(); });
  document.addEventListener('shopify:section:load', function (e) { initHeader(e.target); initHeroSlides(e.target); });
})();
